import React, { useState } from 'react';
import transformArrayToObject from '~/utils/transformArrayToObject';

const AppointmentCategoriesProv = React.createContext({
  data: {
    data: [],
    page: 0,
    totalCount: 0,
  },
  records: {},
  setData: () => null,
  modifyData: () => null,
  deleteRecord: () => null,
});

export function AppointmentCategoriesProvider({ children }) {
  const [records, setRecords] = useState({});
  const [data, setData] = useState({
    data: [],
    page: 0,
    totalCount: 0,
  });

  function addRecords(newData) {
    setData({ ...data, ...newData });

    const newRecords = transformArrayToObject(newData.data);
    setRecords({ ...records, ...newRecords });

    return newData;
  }

  function delRecord(id) {
    const index = data.data.findIndex((r) => r.id === id);
    if (index > -1) {
      data.data.splice(index, 1);
      setData({ ...data, data: [...data.data] });
    }
  }

  return (
    <AppointmentCategoriesProv.Provider
      value={{ data, addRecords, delRecord, records }}
    >
      {children}
    </AppointmentCategoriesProv.Provider>
  );
}

export default AppointmentCategoriesProv;
